import * as CookieConsent from 'vanilla-cookieconsent';

export interface CookieXProps {
  cookieBannerInvisible: () => void;
}

export const cookieX = (props: CookieXProps) => {
  const preferences = CookieConsent.getUserPreferences();
  if (preferences?.acceptedCategories?.includes('necessary')) {
    props.cookieBannerInvisible();
    return;
  }

  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom center',
        equalWeightButtons: false,
        flipButtons: true,
      },
      preferencesModal: {
        layout: 'bar',
        position: 'right',
        equalWeightButtons: false,
        flipButtons: true,
      },
    },
    onFirstConsent: (cookies) => {
      props.cookieBannerInvisible();
    },
    categories: {
      necessary: {
        readOnly: true,
      },
    },
    language: {
      default: 'de',
      autoDetect: 'browser',
      translations: {
        de: {
          consentModal: {
            title: 'Cookies',
            description:
              'Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern.',
            acceptAllBtn: 'Alle akzeptieren',
            acceptNecessaryBtn: 'Alle ablehnen',
            showPreferencesBtn: 'Einstellungen verwalten',
            footer:
              '<a href="/datenschutz">Datenschutz</a>\n<a href="/impressum">Impressum</a>',
          },
          preferencesModal: {
            title: 'Präferenzen für die Zustimmung',
            acceptAllBtn: 'Alle akzeptieren',
            acceptNecessaryBtn: 'Alle ablehnen',
            savePreferencesBtn: 'Einstellungen speichern',
            closeIconLabel: 'Schließen',
            serviceCounterLabel: 'Dienstleistungen',
            sections: [
              {
                title: 'Verwendung von Cookies',
                description:
                  'Wir nutzen Cookies auf unserer Website. Einige von ihnen sind essenziell, während andere uns helfen, diese Website und Ihre Erfahrung zu verbessern.',
              },
              {
                title:
                  'Eessenzielle Cookies <span class="pm__badge">Immer Aktiviert</span>',
                description:
                  'Eessenzielle Cookies sind zum Betrieb der Website erforderlich.',
                linkedCategory: 'necessary',
              },
            ],
          },
        },
      },
    },
  });
};
